
import LandingScreen from "../screen/LandingScreen";
import ContactScreen from "../screen/ContactScreen";


export const routes = [
    {
        path: "/",
        name: "LandingScreen",
        element: <LandingScreen />,
        isPrivate: false
    },
    {
        path: "/contact",
        name: "ContactScreen",
        element: <ContactScreen />,
        isPrivate: false
    },

]
